import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { APIResponse } from 'helpers'
import { PortalArchiveOrderCleanupResponse } from 'modules/support'

export const listRegions = () => ({
  method: 'GET',
  url: '/regions/list'
})

export const getCacheKeys = (searchTerm: string) => ({
  method: 'GET',
  url: `/modules/cache/keys?q=${searchTerm}`
})

export const deleteCacheKeys = (searchTerm: string) => ({
  method: 'DELETE',
  url: `/modules/cache/keys?q=${searchTerm}`
})

export const postPortalArchiveOrderCleanup = () =>
  createAsyncApiAction<APIResponse<PortalArchiveOrderCleanupResponse>>('support', {
    method: 'POST',
    url: `/modules/cleanup/portal-archive-order-cleanup`
  })
